export const POSTHOG_LOCAL_STORAGE_FEATURES_KEY = 'features';

export const POSTHOG_DECIDE_ENDPOINT = '/decide?v=3';
